import React, { useState } from "react";
import { Avatar, Button, Layout, Tooltip, Typography } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  MoonOutlined,
  SearchOutlined,
  SunOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
import { ROUTE_TITLES } from "../menu-items";
import { useAuth } from "../../../hooks/useAuth";
import { useTheme } from "../../../theme/ThemeContext";
import ProfileModal from "../../ProfileModal";

const { Text } = Typography;

// CommandPalette lives in Layout (a sibling, not a descendant of Header) and
// listens for this window CustomEvent to open — avoids wiring a new context
// just to open it from here.
const openCommandPalette = () =>
  window.dispatchEvent(new CustomEvent("open-command-palette"));

const { Header } = Layout;

interface HeaderAppProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

export const HeaderApp: React.FC<HeaderAppProps> = ({
  collapsed,
  setCollapsed,
}) => {
  const location = useLocation();
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [profileOpen, setProfileOpen] = useState(false);

  // Obtener la ruta base (primer segmento después del dominio)
  const basePath = `/${location.pathname.split("/")[1]}`;
  const sectionTitle = ROUTE_TITLES[basePath];

  const initials = user
    ? `${user.first_name?.[0] ?? ""}${user.last_name?.[0] ?? ""}`.toUpperCase()
    : "";

  const themeTooltip = theme === "dark" ? "Modo claro" : "Modo oscuro";

  return (
    <Header className={styles.container}>
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: "16px",
          width: 64,
          height: 64,
        }}
      />
      {sectionTitle && <span className={styles.title}>{sectionTitle}</span>}
      <Button
        type="text"
        icon={<SearchOutlined />}
        onClick={openCommandPalette}
        style={{ marginLeft: "auto", marginRight: 8, color: "white" }}
      >
        Buscar <Text keyboard>Ctrl K</Text>
      </Button>
      <Tooltip title={themeTooltip}>
        <Button
          type="text"
          aria-label={themeTooltip}
          icon={theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
          onClick={toggleTheme}
          style={{ marginRight: 8, color: "white" }}
        />
      </Tooltip>
      <Tooltip title="Mi perfil">
        <Button
          type="text"
          aria-label="Mi perfil"
          onClick={() => setProfileOpen(true)}
          style={{ marginRight: 16, padding: 0, width: 40, height: 40 }}
        >
          <Avatar className={styles.avatar}>{initials}</Avatar>
        </Button>
      </Tooltip>
      <ProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
    </Header>
  );
};
